export const kpiData = [
  {name: 'ResponsivenessSeller', translationKey: 'component.invoice.kpis.seller.seller', walkme: 'sdetails-image-votrereactivite'},
  {name: 'ResponsivenessDebtor', translationKey: 'component.invoice.kpis.seller.debtor', walkme: 'sdetails-image-reactiviteclient'}
];
